<template>
  <div class="anonymity-query">
    <a-page-header style="padding:0" @back="$router.go(-1)" subTitle="串号查询" />
    <my-list :dataSource="dataSource" :loading="loading" :btnConfig="['查看证书','查看二维码','查看文件']"></my-list>
  </div>
</template>

<script>
import { queryDeviceBySerialNumber } from '../api/api'

export default {
  name: 'anonymity-query',

  data() {
    return {
      loading: false,
      dataSource: [],

      visible: false
    }
  },

  computed: {
    serialNumber() {
      return this.$route.params.serialNumber
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      queryDeviceBySerialNumber(this.serialNumber)
        .then(res => {
          if (res.error.code === 0) {
            this.dataSource = [res.response]
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.anonymity-query {
  width: 1300px;
  margin: 0 auto;
  padding: 24px;
}
</style>